import React from 'react';
import PropTypes from 'prop-types';
import calorias from 'images/nutritional-tags/sello_alto_calorias.svg';
import azucares from 'images/nutritional-tags/sello_alto_azucar.svg';
import grasasSaturadas from 'images/nutritional-tags/sello_alto_grasas.svg';
import sodio from 'images/nutritional-tags/sello_alto_sodio.svg';
import style from './style.scss';//NOSONAR

const NutritionalTags = (props) => {
    const translate = {
        calorias,
        azucares,
        grasasSaturadas,
        sodio
    }
    const { tags } = props;

    return(
        <div className="nutritional-flags">
            {tags && tags.map((item, i) => {
                let tag = item;

                if(tag.indexOf('--') != -1) {
                    tag = tag.split('--')[1];
                }

                if(tag.indexOf('-') != -1) {
                    tag = tag.split('-')[0] + tag.split('-')[1].charAt(0).toUpperCase() + tag.split('-')[1].slice(1);
                }

                return <div key={i} className={"nutritional-info-flag"} dangerouslySetInnerHTML={{ __html: translate[tag] || ''}}></div>
            })}
        </div>
    )
}

NutritionalTags.propTypes = {
    tags: PropTypes.array
};

export default NutritionalTags;
